import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "./tablecompare.css";
import { amenityIcons } from "./amenityIcons";
import noImg from '../../../assets/images/no_img.jpg'

const TableCompare = ({ services: initialServices },props) => {
  const [services, setServices] = useState([...initialServices]); // Ensure a copy of the initial array

  const removeRoomFromCompare = (roomId) => {
    setServices((prevServices) => {
      const updatedServices = prevServices.filter((room) => room.serviceId !== roomId);
      return [...updatedServices]; // Return a new array to trigger re-render
    });
  };

  console.log("services::: ", services);

  // Group amenities by category
  const groupedAmenities = services.reduce((acc, room) => {
    room.amenities.forEach((amenity) => {
      if (!acc[amenity.category]) {
        acc[amenity.category] = [];
      }
      if (!acc[amenity.category].some((a) => a.name === amenity.name)) {
        acc[amenity.category].push(amenity);
      }
    });
    return acc;
  }, {});

  return (
    <>
      {services?.length > 0 ? (
        <table className="table compare_table table-bordered text-center align-middle">
          <thead>
            <tr>
              <th className="text-start heading_title_compare_room">
                Room Detail
              </th>

              {services?.map((room, index) => (
                <th key={index} className="position-relative">
                  <p
                    style={{ fontWeight: 500, width: 230, textAlign: "center" }}
                    className="m-0 font-weight-normal"
                  >
                    {room.name}
                  </p>
                  <button
                    type="button"
                    className=" close_btn_comapre  opacity-100 position-absolute d-flex justify-content-center top-0 end-0 m-2"
                    aria-label="Remove"
                    onClick={() => {
                      removeRoomFromCompare(room?.serviceId);
                    }}
                  >
                    X
                  </button>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {/* Room Images */}
            <tr>
              <td className="text-start heading_title_compare_room room_title">
                <strong>Room Image</strong>
              </td>
              {services?.map((room, index) => (
                <td key={index}>
                  <div
                    style={{ width: "300px", margin: "0 auto" }}
                    id={`carousel-${index}`}
                    className="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div className="carousel-inner" style={{}}>
                      {(room?.gallery || []).map((img, i) => (
                        <div
                          className={`carousel-item ${i === 0 ? "active" : ""}`}
                          key={i}
                        >
                          <img
                            src={img.attachment}
                            className="d-block w-100"
                            alt={`Slide ${i}`}
                            style={{
                              width: "200px",
                              height: "200px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                    {room?.gallery?.length > 1 ? (
                      <>
                        <button
                          className="carousel-control-prev"
                          type="button"
                          data-bs-target={`#carousel-${index}`}
                          data-bs-slide="prev"
                        >
                          <span
                            className="carousel-control-prev-icon"
                            aria-hidden="true"
                          ></span>
                          <span className="visually-hidden">Previous</span>
                        </button>
                        <button
                          className="carousel-control-next"
                          type="button"
                          data-bs-target={`#carousel-${index}`}
                          data-bs-slide="next"
                        >
                          <span
                            className="carousel-control-next-icon"
                            aria-hidden="true"
                          ></span>
                          <span className="visually-hidden">Next</span>
                        </button>
                      </>
                    ) : (
                      <img
                        style={{
                          width: "200px",
                          height: "200px",
                          objectFit: "cover",
                        }}
                        src={noImg}
                        alt="noIMg"
                        loading="lazy"
                      />
                    )}
                  </div>
                </td>
              ))}
            </tr>

            {/* Base Rate */}
            <tr>
              <td className="text-start heading_title_compare_room">
                <strong>Room Rate</strong>
              </td>
              {services?.map((room, index) => {
                const ratePlan = room?.ratetypes[0]?.rateplans || [];
                const total = ratePlan.reduce(
                  (sum, item) => sum + (item?.rate?.Base || 0),
                  0
                ).toFixed(2); // Calculate total
                return <td key={index}>${total || "N/A"}</td>; // Display total
              })}
            </tr>

            {/* Min Nights */}
            {/* <tr>
     <td className="text-start heading_title_compare_room">
       <strong>Min Nights</strong>
     </td>
     {services?.map((room, index) => (
       <td key={index}>{room.minnights}</td>
     ))}
   </tr> */}

            {/* Capacity */}
            <tr>
              <td className="text-start heading_title_compare_room">
                <strong>Max Occupancy</strong>
              </td>
              {services?.map((room, index) => (
                <td key={index}>
                  {room.capacity.adult} Adults, {room.capacity.child} Children
                </td>
              ))}
            </tr>

            {/* Amenities Section */}
            {Object.entries(groupedAmenities).map(
              ([category, amenities], categoryIndex) => (
                <React.Fragment key={categoryIndex}>
                  {/* Category Title Row */}
                  <tr>
                    <td
                      colSpan={services.length + 1}
                      className="text-start heading_title_compare_room bg-light"
                    >
                      <strong>{category}</strong>
                    </td>
                  </tr>

                  {/* Each Amenity as a Row */}
                  {amenities.map((amenity, amenityIndex) => (
                    <tr key={amenityIndex}>
                      <td
                        style={{ width: 300 }}
                        className="text-start heading_title_compare_room"
                        title={amenity.name}
                      >
                        {amenityIcons[amenity.name]} &nbsp;{amenity.name}
                      </td>
                      {services.map((room, roomIndex) => {
                        const hasAmenity = room?.amenities?.some(
                          (a) => a?.name === amenity.name
                        );
                        return (
                          <td key={roomIndex}>
                            {hasAmenity ? (
                              <span className="text-success">✔</span>
                            ) : (
                              <span className="text-danger">✘</span>
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </React.Fragment>
              )
            )}
          </tbody>
        </table>
      ) : (
        <div style={{minHeight:"50vh"}} className="d-flex justify-content-center align-items-center">
         No rooms found to compare
        </div>
      )}
    </>
  );
};

export default TableCompare;
